import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTenantService } from 'hooks/iam/tenant';

export const TenantContext = React.createContext({
  tenant: {},
  is_loading: true,
  is_agency_managed: false,
  refetchTenant: () => {}
});

export const TenantProvider = ({ children }) => {
  const { tenant_id } = useSelector((store) => store.user_data);
  const { fetchTenant } = useTenantService();

  const [tenant, setTenant] = useState({});
  const [is_loading, setIsLoading] = useState(true);

  const loadTenant = useCallback(() => {
    if (!tenant_id) return;
    setIsLoading(true);
    fetchTenant(tenant_id)
      .then(({ tenant }) => setTenant(tenant || {}))
      .finally(() => setIsLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenant_id]);

  useEffect(() => {
    loadTenant();
  }, [loadTenant]);

  // A tenant linked to an agency carries that agency's id in `agent_id`.
  // Such organisations are billed/managed by their agency, so they cannot
  // see invoices, buy credits or buy subscriptions themselves.
  const is_agency_managed = !!tenant?.agent_id;

  const value = { tenant, is_loading, is_agency_managed, refetchTenant: loadTenant };
  return <TenantContext.Provider value={value}>{children}</TenantContext.Provider>;
};

export const useTenant = () => useContext(TenantContext);
